<p-menubar [model]="navigationItems" [dt]="menubarHeaderDesignToken">
  <ng-template #start>
    <div class="start-content">
      <div class="brand-text" (click)="navigateToDashboard()">WEB ANALYTICS</div>
    </div>
  </ng-template>
  <ng-template #end>
    <div class="end-content">
      <a [href]="homeUrl">
        @if (isMobile$ | async) {
          <img class="traton-logo-mobile" alt="Traton logo" src="assets/traton/logos/TRATON_Super_sign_RGB_White.svg" />
        } @else {
          <img class="traton-logo" alt="Traton logo" src="assets/traton/logos/TRATON_Logo_RGB_white.png" />
        }
      </a>
      <p-button
        #menuButton
        raised="true"
        severity="secondary"
        variant="outlined"
        size="small"
        icon="pi pi-bars"
        (onClick)="menu.toggle($event)"
      ></p-button>
    </div>
    <p-tieredmenu #menu [dt]="menuDesignToken" popup="true" [model]="(menuItems$ | async) ?? undefined" appendTo="body">
      @if (authService.userData$ | async; as userData) {
        <p-drawer [dt]="drawerDesignToken" header="User details" [(visible)]="showUserDetails" modal="true" position="right" closable="true">
          @defer (when showUserDetails) {
            @if (userData) {
              <div class="table-container">
                <div>
                  <table>
                    <tr>
                      <td class="table-row">Name</td>
                      <td class="table-row">{{ userData?.firstName }} {{ userData?.lastName }}</td>
                    </tr>
                    <tr>
                      <td class="table-row">Company</td>
                      <td class="table-row">{{ userData?.companyName }}</td>
                    </tr>
                    <tr>
                      <td class="table-row">Username</td>
                      <td class="table-row">{{ userData?.userName }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            } @else {
              <div style="align-items: center; display: flex">
                <p-progressSpinner></p-progressSpinner>
              </div>
            }
          }
        </p-drawer>
      }
      <p-drawer
        header="Settings"
        [(visible)]="showSettings"
        modal="true"
        position="right"
        [closable]="true"
        [dt]="drawerDesignToken"
      >
        <div class="table-container">
          <div class="table-content">
            <table>
              <tr>
                <td class="table-row">Dark Mode</td>
                <td class="table-row">
                  @if (themeService.theme$ | async; as theme) {
                    <p-toggleSwitch [ngModel]="theme === Theme.Dark" (onChange)="themeService.toggleTheme()" />
                  }
                </td>
              </tr>
              <tr>
                <td class="table-row">Colorblind Mode</td>
                <td class="table-row">
                  <p-toggleSwitch
                    [ngModel]="colorblindService.colorblindMode$ | async"
                    (onChange)="colorblindService.toggleColorblindMode()"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </p-drawer>
    </p-tieredmenu>
  </ng-template>
</p-menubar>
